<div class="modal-backdrop" #backdrop (click)="close()"></div>

<div class="modal-wrapper">
  <div class="modal-card" #card>
    <div class="modal-header">
      <h5 class="modal-title">
        {{ "askToSpecialistModal.consultationQrCode" | translate }}
      </h5>
      <p class="modal-subtitle">
        {{ "askToSpecialistModal.pleaseScanThisQrCode" | translate }}
      </p>
    </div>

    @if (isPwa && qrButtonLink) {
    <div class="text-center mb-3">
      <a [href]="qrButtonLink" target="_blank" class="btn btn-primary btn-sm">
        {{ "redirectToApp" | translate }}
      </a>
    </div>
    }

    <div class="qr-container">
      <div class="qr-frame">
        <img *ngIf="qrCodeUrl" [src]="qrCodeUrl" alt="QR Code" />
        <div *ngIf="!qrCodeUrl" class="spinner-border text-primary"></div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-close-modal" (click)="close()">
        {{ "askToSpecialistModal.close" | translate }}
      </button>
    </div>
  </div>
</div>